import toast from 'react-hot-toast';

/**
 * Un mismo aviso de error no se muestra dos veces (encontrado en F15, 25/10).
 *
 * El interceptor de `utils/api.js` avisa de todo error de la API, y además cada
 * pantalla avisa el suyo en su `catch` (hay decenas): el usuario veía el mismo
 * mensaje dos veces. Con el texto como `id`, react-hot-toast reemplaza el aviso
 * repetido en vez de apilar otro. Un `id` explícito de quien llama se respeta.
 */
const original = toast.error;
toast.error = (mensaje, opciones = {}) =>
  original(mensaje, typeof mensaje === 'string' ? { id: `error:${mensaje}`, ...opciones } : opciones);

export default toast;
